
  import {defineComponent} from "vue";
  import router from "@/router";
  import {NamedRouting} from "@/domain/utils/NamedRouting";

  export default defineComponent({
    name: "no-ticket-component",
    props: ['isEmpty', 'showGiftImage'],
    methods: {
      moveToHome(): void {
        router.push(new NamedRouting('HomeView'));
      }
    }
  });
